module.exports = __webpack_public_path__ + "static/img/多维度资金数据分析监控.b49ecfb0.png";